import _asyncToGenerator from "@babel/runtime/helpers/asyncToGenerator";
import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _regeneratorRuntime from "@babel/runtime/regenerator";

var MollieInline = /*#__PURE__*/function () {
  function MollieInline(apiKey) {
    _classCallCheck(this, MollieInline);

    this.mollie = Mollie(apiKey, {
      locale: window.locale
    });
    this.mountFields();
  }

  _createClass(MollieInline, [{
    key: "createCardToken",
    value: function createCardToken() {
      var _this = this;

      return new Promise( /*#__PURE__*/function () {
        var _ref = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(res, rej) {
          var _yield$_this$mollie$c, token, error;

          return _regeneratorRuntime.wrap(function _callee$(_context) {
            while (1) {
              switch (_context.prev = _context.next) {
                case 0:
                  _context.next = 2;
                  return _this.mollie.createToken();

                case 2:
                  _yield$_this$mollie$c = _context.sent;
                  token = _yield$_this$mollie$c.token;
                  error = _yield$_this$mollie$c.error;

                  if (error) {
                    rej(error);
                  }

                  return _context.abrupt("return", res(token));

                case 7:
                case "end":
                  return _context.stop();
              }
            }
          }, _callee);
        }));

        return function (_x, _x2) {
          return _ref.apply(this, arguments);
        };
      }());
    }
  }, {
    key: "mountFields",
    value: function mountFields() {
      var cardHolder = this.mollie.createComponent('cardHolder');
      cardHolder.mount('#card-holder');
      var cardHolderError = document.getElementById('card-holder-error');
      cardHolder.addEventListener('change', function (event) {
        if (event.error && event.touched) {
          cardHolderError.textContent = event.error;
        } else {
          cardHolderError.textContent = '';
        }
      });
      var cardNumber = this.mollie.createComponent('cardNumber');
      cardNumber.mount('#card-number');
      var cardNumberError = document.getElementById('card-number-error');
      cardNumber.addEventListener('change', function (event) {
        if (event.error && event.touched) {
          cardNumberError.textContent = event.error;
        } else {
          cardNumberError.textContent = '';
        }
      });
      var expiryDate = this.mollie.createComponent('expiryDate');
      expiryDate.mount('#expiry-date');
      var expiryDateError = document.getElementById('expiry-date-error');
      expiryDate.addEventListener('change', function (event) {
        if (event.error && event.touched) {
          expiryDateError.textContent = event.error;
        } else {
          expiryDateError.textContent = '';
        }
      });
      var verificationCode = this.mollie.createComponent('verificationCode');
      verificationCode.mount('#verification-code');
      var verificationCodeError = document.getElementById('verification-code-error');
      verificationCode.addEventListener('change', function (event) {
        if (event.error && event.touched) {
          verificationCodeError.textContent = event.error;
        } else {
          verificationCodeError.textContent = '';
        }
      }); // reset card token

      var cardToken = document.getElementById('card-token');
      cardToken.value = '';
    }
  }]);

  return MollieInline;
}();

export default MollieInline;